export default __webpack_public_path__ + "static/media/pa_2.18a1a9d2.mp3";